import { create } from 'zustand';
import { CalendarDto as BaseCalendarDto, defaultCalendarDto, defaultEventCategories, CalendarViewType, EventCategory } from 'src/dtos/calendar/calendarDto';
import { dateUtils, eventUtils } from './utils/calendarUtils';

// CalendarDto에 systemDayDate(Date) 확장
export interface CalendarDtoWithDate extends BaseCalendarDto {
	systemDayDate?: Date;
}

interface CalendarStore {
	currentDate: Date;
	viewType: CalendarViewType;
	events: CalendarDtoWithDate[];
	categories: EventCategory[];
	selectedEvent: CalendarDtoWithDate | null;
	isEventModalOpen: boolean;
	isLoading: boolean;
	selectedDate: Date | null;
	selectedCompCd: string;

	// 상태 설정 액션
	setCurrentDate: (date: Date) => void;
	setViewType: (viewType: CalendarViewType) => void;
	setEvents: (events: CalendarDtoWithDate[]) => void;
	setSelectedEvent: (event: CalendarDtoWithDate | null) => void;
	setEventModalOpen: (isOpen: boolean) => void;
	setLoading: (isLoading: boolean) => void;
	setSelectedDate: (date: Date | null) => void;
	setSelectedCompCd: (compCd: string) => void;

	// 이벤트 관리 액션
	addEvent: (event: CalendarDtoWithDate) => void;
	updateEvent: (event: CalendarDtoWithDate) => void;
	deleteEvent: (compCd: string, systemDay: string) => void;

	// 유틸리티 함수
	getEventsForDate: (date: Date) => CalendarDtoWithDate[];
	getEventsForMonth: (year: number, month: number) => CalendarDtoWithDate[];
	getHolidayEvents: () => CalendarDtoWithDate[];

	// 네비게이션 액션
	navigateToNextMonth: () => void;
	navigateToPrevMonth: () => void;
	navigateToToday: () => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	

	// 초기화
	initData: () => void;
}

export const useSYS4110_R01Store = create<CalendarStore>((set, get) => ({
	// 초기 상태
	currentDate: new Date(),
	viewType: 'month',
	events: [],
	categories: defaultEventCategories,
	selectedEvent: null,
	isEventModalOpen: false,
	isLoading: false,
	selectedDate: null,
	selectedCompCd: '',

	// 상태 설정 액션
	setCurrentDate: (date) => set({ currentDate: date }),
	setViewType: (viewType) => set({ viewType }),
	setEvents: (events) => set({ events }),
	setSelectedEvent: (event) => set({ selectedEvent: event }),
	setEventModalOpen: (isOpen) => set({ isEventModalOpen: isOpen }),
	setLoading: (isLoading) => set({ isLoading }),
	setSelectedDate: (date) => set({ selectedDate: date }),
	setSelectedCompCd: (compCd) => set({ selectedCompCd: compCd }),

	// 이벤트 관리 액션
	addEvent: (event) => set((state) => ({ 
		events: [...state.events, event] 
	})),
	
	updateEvent: (event) => set((state) => ({
		events: state.events.map(e => 
			e.compCd === event.compCd && e.systemDay === event.systemDay ? event : e
		)
	})),
	
	deleteEvent: (compCd, systemDay) => set((state) => ({
		events: state.events.filter(e => 
			!(e.compCd === compCd && e.systemDay === systemDay)
		)
	})),

	// 유틸리티 함수 (유틸리티 함수 활용)
	getEventsForDate: (date) => {
		const { events } = get();
		// 로컬 타임존 기준 YYYY-MM-DD
		const y = date.getFullYear();
		const m = date.getMonth() + 1;
		const d = date.getDate();
		const localDateStr = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
		return events.filter(event => {
			if (typeof event.systemDay === 'string') {
				return event.systemDay.substring(0, 10) === localDateStr;
			}
			return false;
		});
	},

	getEventsForMonth: (year, month) => {
		const { events } = get();
		return eventUtils.getEventsForMonth(events, year, month);
	},

	getHolidayEvents: () => {
		const { events } = get();
		return eventUtils.getHolidayEvents(events);
	},

	// 네비게이션 액션
	navigateToNextMonth: () => {
		const { currentDate } = get();
		const nextMonth = new Date(currentDate);
		nextMonth.setMonth(currentDate.getMonth() + 1);
		set({ currentDate: nextMonth });
	},

	navigateToPrevMonth: () => {
		const { currentDate } = get();
		const prevMonth = new Date(currentDate);
		prevMonth.setMonth(currentDate.getMonth() - 1);
		set({ currentDate: prevMonth });
	},

	navigateToToday: () => {
		set({ currentDate: new Date() });
	},
	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),
						

	// 초기화
	initData: () => set({
		currentDate: new Date(),
		viewType: 'month',
		events: [],
		selectedEvent: null,
		isEventModalOpen: false,
		isLoading: false,
		selectedDate: null,
		selectedCompCd: '',
		allCount: 0
	}),
})); 	